import * as PourOver from 'pourover';

import { FilterBase, unionMembers } from './FilterBase';

export class SellersWithCrossesFilter extends FilterBase {
  constructor(private allSellerIds) {
    super();
  }

  makeIndex(): any {
    return new PourOver.makeInclusionFilter(
      'sellersWithCrosses',
      this.allSellerIds
    );
  }

  getMatchSet(collection: any, filterSettings): any {
    if (filterSettings.crossesBySellers.length) {
      return unionMembers(
        filterSettings.crossesBySellers,
        collection.filters.sellersWithCrosses
      );
    }
  }

  getCounts(): any {
    return {};
  }
}
